import { PenTool, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/button';

interface WhiteboardEmptyStateProps {
  onCreate: () => void;
  canCreate: boolean;
}

export function WhiteboardEmptyState({ onCreate, canCreate }: WhiteboardEmptyStateProps) {
  const { t } = useTranslation('whiteboards');

  return (
    <div
      className="flex h-full flex-col items-center justify-center px-6 py-12 text-center"
      data-testid="whiteboards-empty-state"
    >
      <PenTool className="mb-4 h-12 w-12 text-muted-foreground" />
      <h3 className="text-base font-semibold text-foreground">{t('list.empty')}</h3>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground">{t('list.emptyDescription')}</p>

      {canCreate && (
        <Button className="mt-6" onClick={onCreate} data-testid="whiteboards-create-button">
          <Plus className="mr-2 h-4 w-4" />
          {t('actions.create')}
        </Button>
      )}
    </div>
  );
}
